module.exports = __webpack_public_path__ + "static/img/app.a989128e.png";